const ElementPrivacy = (window.ElementPrivacy || window.ElementBase).extend(/** @lends ElementPrivacy.prototype */ {});

export default ElementPrivacy;